var moment = require('moment');

export default {

    convertDateBrToEua(data) {
        let dt = data.split('/');
        return dt[2] + '-' + dt[1] + '-' + dt[0];
    },
    numberToReal: function (numero, sifrao) {
        if (numero) {

            var numero = parseFloat(numero);
            numero = numero.toFixed(2).split('.');

            if (sifrao) {
                numero[0] = "R$ " + numero[0].split(/(?=(?:...)*$)/).join('.');
            } else {
                numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.');
            }
            return numero.join(',');
        }
        return '0,00';
    },

    numberToRealCasas: function (numero, casas = 0) {
        if (numero) {

            if (numero >= 0) {
                var n = parseFloat(numero);
            } else {
                var n = Math.abs(numero);
            }

            n = n.toFixed(casas).split('.');
            n[0] = n[0].split(/(?=(?:...)*$)/).join('.');

            if (numero < 0) {
                return '-' + n.join(',');
            }

            return n.join(',');
        }
        return '0';
    },

    apenasNumeros: function (string) {
        if (string != '') {
            var numsStr = string.replace(/[^0-9]/g, '');
            return parseInt(numsStr);
        }

    },

    getEstados() {
        return [
            { id: 1, nome: "Acre", sigla: "AC" },
            { id: 2, nome: "Alagoas", sigla: "AL" },
            { id: 4, nome: "Amap\u00e1", sigla: "AP" },
            { id: 3, nome: "Amazonas", sigla: "AM" },
            { id: 5, nome: "Bahia", sigla: "BA" },
            { id: 6, nome: "Cear\u00e1", sigla: "CE" },
            { id: 7, nome: "Distrito Federal", sigla: "DF" },
            { id: 8, nome: "Espirito Santo", sigla: "ES" },
            { id: 9, nome: "Goi\u00e1s", sigla: "GO" },
            { id: 10, nome: "Maranh\u00e3o", sigla: "MA" },
            { id: 13, nome: "Mato Grosso", sigla: "MT" },
            { id: 12, nome: "Mato Grosso do Sul", sigla: "MS" },
            { id: 11, nome: "Minas Gerais", sigla: "MG" },
            { id: 14, nome: "Par\u00e1", sigla: "PA" },
            { id: 15, nome: "Para\u00edba", sigla: "PB" },
            { id: 18, nome: "Paran\u00e1", sigla: "PR" },
            { id: 16, nome: "Pernambuco", sigla: "PE" },
            { id: 17, nome: "Piau\u00ed", sigla: "PI" },
            { id: 19, nome: "Rio de Janeiro", sigla: "RJ" },
            { id: 20, nome: "Rio Grande do Norte", sigla: "RN" },
            { id: 23, nome: "Rio Grande do Sul", sigla: "RS" },
            { id: 21, nome: "Rond\u00f4nia", sigla: "RO" },
            { id: 22, nome: "Roraima", sigla: "RR" },
            { id: 24, nome: "Santa Catarina", sigla: "SC" },
            { id: 26, nome: "S\u00e3o Paulo", sigla: "SP" },
            { id: 25, nome: "Sergipe", sigla: "SE" },
            { id: 27, nome: "Tocantins", sigla: "TO" },
        ];
    },

    formatDate(value, fmt = 'DD/MM/YYYY') {

        return (value == null)
            ? ''
            : moment(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
    },


    convert_pa_tcf: function ($pa) {

        if ($pa == 1) {
            return 'UAD';
        }

        if ($pa == 17) {
            return 29;
        }

        if ($pa == 18) {
            return 30;
        }

        if ($pa == 19) {
            return 16;
        }

        return $pa - 1;
    },

    convert_pa_crediauc: function ($pa) {

        if ($pa == 29) {
            return 17;
        }

        if ($pa == 30) {
            return 18;
        }

        if ($pa == 16) {
            return 19;
        }

        return parseFloat($pa) + parseFloat(1);
    },

    validaCPF: function (strCPF) {

        var Soma;
        var Resto;
        Soma = 0;

        if (strCPF == "00000000000") {
            return false;
        }

        for (var i = 1; i <= 9; i++) {
            Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
        }

        Resto = (Soma * 10) % 11;

        if ((Resto == 10) || (Resto == 11)) {
            Resto = 0;
        }

        if (Resto != parseInt(strCPF.substring(9, 10))) {
            return false;
        }

        Soma = 0;

        for (var i = 1; i <= 10; i++) {
            Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
        }

        Resto = (Soma * 10) % 11;

        if ((Resto == 10) || (Resto == 11)) {
            Resto = 0;
        }

        if (Resto != parseInt(strCPF.substring(10, 11))) {
            return false;
        }
        return true;
    },

    validaCNPJ: function (cnpj) {

        cnpj = cnpj.toString().replace(/[^\d]+/g, '');

        if (cnpj == '') {

            return false;
        }

        if (cnpj.length != 14 || cnpj == "00000000000000" || cnpj == "11111111111111" || cnpj == "22222222222222" || cnpj == "33333333333333" || cnpj == "44444444444444" || cnpj == "55555555555555" || cnpj == "66666666666666" || cnpj == "77777777777777" || cnpj == "88888888888888" || cnpj == "99999999999999") {

            return false;
        }

        var tamanho = cnpj.length - 2;
        var numeros = cnpj.substring(0, tamanho);
        var digitos = cnpj.substring(tamanho);
        var soma = 0;
        var pos = tamanho - 7;
        var resultado;

        for (var i = tamanho; i >= 1; i--) {

            soma += numeros.charAt(tamanho - i) * pos--;

            if (pos < 2) {

                pos = 9;
            }
        }

        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

        if (resultado != digitos.charAt(0)) {

            return false;
        }

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;

        for (i = tamanho; i >= 1; i--) {

            soma += numeros.charAt(tamanho - i) * pos--;

            if (pos < 2) {

                pos = 9;
            }
        }

        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;

        if (resultado != digitos.charAt(1)) {

            return false;
        }

        return true;
    },

    formataCNPJ: function (campo) {
        return campo.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");

    },

    loading: function () {
        swal({
            title: "Aguarde",
            imageUrl: "/images/ellipsis.gif",
            showConfirmButton: false,
        });
    }

}




// WEBPACK FOOTER //
// ./src/helpers/Utils.js